<h2 mat-dialog-title>{{'DialogAddExtensions.Title'|translate}}</h2>

@if (extensions.length > 0) {
  <div class="selection-list-container" mat-dialog-content>
    <mat-form-field>
      <mat-label>{{'DialogAddExtensions.Search'|translate}}</mat-label>
      <input matInput [formControl]="search">
      <button mat-icon-button type="button" matSuffix color="primary" (click)="deleteSearch()">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>
    <mat-selection-list #extensionsList (selectionChange)="selectionChange($event.options)">
      @for (extension of $search|async; track extension) {
        <mat-list-option [value]="extension"
          [selected]="selectedExtensionsControl.value && selectedExtensionsControl.value?.indexOf(extension) >= 0">
          {{extension.number}} - {{extension.name}}
        </mat-list-option>
      }
    </mat-selection-list>
  </div>
}

@if (extensions.length < 1) {
  <div>{{'DialogAddExtensions.NoMoreExtensions'|translate}}</div>
}

<mat-dialog-actions>
  <button mat-raised-button (click)="close()">{{'DialogAddExtensions.CancelButton'|translate}}</button>
  <button mat-raised-button color="primary"(click)="confirm()">{{'DialogAddExtensions.ValidButton'|translate}}</button>
</mat-dialog-actions>
